import type { AppStep } from "./constants";

export function AppStepCards({
  label,
  steps,
  className = "",
}: {
  label?: string;
  steps: readonly AppStep[];
  className?: string;
}) {
  return (
    <div className={`app-step-cards ${className}`.trim()}>
      {label && <p className="app-step-cards-label">{label}</p>}
      <ol className="app-step-cards-grid">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <li className={`app-step-card app-step-card--${step.tone || "neutral"}`} key={step.title}>
              <span className="app-step-card-index" aria-hidden="true">{index + 1}</span>
              <span className="app-step-card-orbit" aria-hidden="true">
                <Icon size={18} />
              </span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
